import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";

import AppRoutes from './Routing/AppRoutes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppRoutes/>
);
